import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d17c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-top" }
const _hoisted_2 = { class: "sticky-top navbar navbar-expand-lg navbar-light shadow-sm" }
const _hoisted_3 = { class: "container-fluid px-lg-5 h-100 d-flex align-items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["aria-expanded"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "w-100 h-100 navbar-nav mb-2 mb-lg-0 justify-content-lg-center" }
const _hoisted_9 = { class: "w-25" }
const _hoisted_10 = { class: "h-100 navbar-nav mb-2 mb-lg-0 justify-content-lg-end" }
const _hoisted_11 = { class: "nav-item d-none" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RegisterModal = _resolveComponent("RegisterModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            exact: "",
            "exact-active-class": "active",
            class: "navbar-brand",
            to: "/",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggledNav = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require(`@/assets/img/logo/logo.png`),
                alt: "logo.jpg",
                width: "50",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggledNav = false))
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: _normalizeClass(["navbar-toggler btn btn-transparent border-0", [_ctx.toggledNav ? 'collapsed' : '']]),
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#navbarText",
            "aria-controls": "navbarText",
            "aria-expanded": _ctx.toggledNav,
            "aria-label": "Toggle navigation"
          }, _hoisted_7, 10, _hoisted_5),
          _createElementVNode("div", {
            class: _normalizeClass(["w-100 collapse navbar-collapse", [_ctx.toggledNav ? 'show' : '']]),
            id: "navbarText"
          }, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Navigation, (Nav) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: Nav.path,
                  class: "nav-item"
                }, [
                  _createVNode(_component_router_link, {
                    exact: "",
                    "active-class": "active",
                    class: "nav-link",
                    to: Nav.path,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggledNav = !_ctx.toggledNav))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(Nav.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: "",
                      class: "nav-link",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.registerModal = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Registration")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_12, [
                    (!_ctx.authStatus)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          exact: "",
                          "exact-active-class": "active",
                          class: "nav-link",
                          to: "/auth/login"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Log in")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", _hoisted_13, [
                    (_ctx.authStatus)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "#",
                          class: "nav-link",
                          icon: "pi pi-microsoft",
                          onClick: _ctx.goBackToDashboard
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Dashboard")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", _hoisted_14, [
                    (_ctx.authStatus)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "",
                          class: "nav-link",
                          onClick: _ctx.logout
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Log-out")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ], 2)
        ])
      ])
    ]),
    (_ctx.registerModal)
      ? (_openBlock(), _createBlock(_component_RegisterModal, {
          key: 0,
          onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.registerModal = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}